/* eslint-disable class-methods-use-this */
import Api from 'api/v2/Api';
import axios from 'axios';

class OauthApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/oauth';
  }

  async createOauthProviderLink(oauthProvider) {
    await this.initialize();
    return axios.post(`${this.baseUrl}/${oauthProvider}`);
  }

  async deleteOauthProviderLink(oauthProvider) {
    await this.initialize();
    return axios.delete(`${this.baseUrl}/${oauthProvider}`);
  }
}

export default new OauthApi();
